import { colors } from 'config/themes/colors';
import styled from 'styled-components';

export const UploadPlaceholderStyled = styled.div`
  padding: 23px;
  border: 1px solid
    ${({ theme }) => (theme.name === 'atsDark' ? colors.gray[700] : colors.gray[100])};
  border-radius: 5px;
  background: ${({ theme }) => theme.background.panel};
  cursor: pointer;
`;
